import React from "react";
import { Button, Card, List } from "semantic-ui-react";

import IDisciplinaryMatter from "../../../data/priest/DisciplinaryMatter";
import "../../../static/priestProfile.css";
import CardRow from "../CardRow";

interface IDisciplinaryMatterCardProps {
    disciplinaryMatter: IDisciplinaryMatter;
    index: number;
    editMode: boolean;
    handleDelete: (index: number) => void;
    handleChangeOnDisciplinaryMatter: (labelName: string, value: any, index: number) => void;
}

const DisciplinaryMatterCard: React.FC<IDisciplinaryMatterCardProps> = (props: IDisciplinaryMatterCardProps) => {
    const { disciplinaryMatter, index, editMode, handleDelete, handleChangeOnDisciplinaryMatter } = props;

    const handleOnClick = () => {
        handleDelete(index);
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Content>
                    {editMode && <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleOnClick} />}
                </Card.Content>

                <Card.Description>
                    <List>
                        <List.Item>
                            <CardRow
                                data={disciplinaryMatter.name}
                                dataName="name"
                                editMode={editMode}
                                index={index}
                                labelName="disciplinaryMatterName"
                                setValue={handleChangeOnDisciplinaryMatter}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRow
                                data={disciplinaryMatter.issuingAuthority}
                                editMode={editMode}
                                index={index}
                                labelName="issuingAuthority"
                                setValue={handleChangeOnDisciplinaryMatter}
                            />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    );
};

export default DisciplinaryMatterCard;
